"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PureCss;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _clsx3 = _interopRequireDefault(require("clsx"));
var style = require("./style_css.js")["default"];
function PureCss(props) {
  var _clsx;
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var wapp = context.wapp,
    req = context.req;
  var fullPage = props.fullPage,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? true : _props$fullWidth,
    progressRef = props.progressRef,
    editor = props.editor,
    className = props.className;
  wapp.styles.use(style);
  var container = (0, _react.useRef)();
  var scaleRef = (0, _react.useRef)();
  var containers = (0, _react.useMemo)(function () {
    return {};
  }, []);
  if (!containers[wapp.globals.WAPP]) {
    containers[wapp.globals.WAPP] = {};
  }
  function getScale() {
    var parentContainer = containers[wapp.globals.WAPP].current || typeof window !== "undefined" && window;
    var scaleContainer = containers[wapp.globals.WAPP].scale && containers[wapp.globals.WAPP].scale.children[0];
    if (parentContainer && scaleContainer) {
      return Math.min(parentContainer.offsetWidth / scaleContainer.offsetWidth, parentContainer.offsetHeight / scaleContainer.offsetHeight);
    }
    return 1;
  }
  var _useState = (0, _react.useState)(getScale()),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    scale = _useState2[0],
    setScale = _useState2[1];
  var customStyle = (0, _react.useRef)();
  var query = req.wappRequest.query;
  var index = typeof query.index === "string" && Number(query.index) >= 0 ? Number(query.index) : 0;
  if (!customStyle.current) {
    customStyle.current = {};
    customStyle.current.styles = ["", "style1", "style2", "style4", "style5"];
    customStyle.current.i = customStyle.current.styles[index] ? index : 0;
    customStyle.current.className = customStyle.current.styles[customStyle.current.i];
    customStyle.current.lastChange = Date.now();
  }
  var changeStyle = function changeStyle() {
    if (customStyle.current.i >= 0) {
      console.log("[APP] Animation ended " + customStyle.current.i);
    }
    clearTimeout(customStyle.current.inactiveTimeout);
    container.current.classList.remove(style.animation);
    if (customStyle.current.className && style[customStyle.current.className]) {
      container.current.classList.remove(style[customStyle.current.className]);
    }
    customStyle.current.i = customStyle.current.styles[customStyle.current.i + 1] ? customStyle.current.i + 1 : 0;
    customStyle.current.className = customStyle.current.styles[customStyle.current.i];
    customStyle.current.lastChange = Date.now();
    setTimeout(function () {
      customStyle.current.inactiveTimeout = setTimeout(function () {
        changeStyle();
      }, 5000);
      container.current.classList.add(style.animation);
      if (customStyle.current.className && style[customStyle.current.className]) {
        container.current.classList.add(style[customStyle.current.className]);
      }
    });
  };
  if (wapp.target !== "node") {
    (0, _react.useLayoutEffect)(function didMount() {
      var calledOnce = false;
      function onResize() {
        return _onResize.apply(this, arguments);
      }
      function _onResize() {
        _onResize = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
          var scale, _progressRef$current, _progressRef$current$;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                scale = getScale();
                _context.next = 3;
                return setScale(scale);
              case 3:
                if (calledOnce) {
                  _context.next = 12;
                  break;
                }
                calledOnce = true;
                _context.next = 7;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1000);
                });
              case 7:
                if (!(progressRef !== null && progressRef !== void 0 && (_progressRef$current = progressRef.current) !== null && _progressRef$current !== void 0 && (_progressRef$current$ = _progressRef$current.actions) !== null && _progressRef$current$ !== void 0 && _progressRef$current$.setShow)) {
                  _context.next = 10;
                  break;
                }
                _context.next = 10;
                return progressRef.current.actions.setShow({
                  message: "",
                  value: false
                });
              case 10:
                console.log("[APP] Add objects...");
                console.log("[APP] Call onComplete...");
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return _onResize.apply(this, arguments);
      }
      function addResizeListeners() {
        if (container.current && typeof ResizeObserver !== "undefined") {
          var resizeObserver = new ResizeObserver(function (entries) {
            onResize(entries);
          });
          resizeObserver.observe(container.current);
          return function removeEventListener() {
            resizeObserver.disconnect();
          };
        } else {
          window.addEventListener("resize", onResize);
          return function removeEventListener() {
            window.removeEventListener("resize", onResize);
          };
        }
      }
      containers[wapp.globals.WAPP].current = container.current;
      containers[wapp.globals.WAPP].scale = scaleRef.current;
      function onResizeAndAddTimeout() {
        return _onResizeAndAddTimeout.apply(this, arguments);
      }
      function _onResizeAndAddTimeout() {
        _onResizeAndAddTimeout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return onResize();
              case 2:
                _context2.next = 4;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1000);
                });
              case 4:
                if (customStyle.current.inactiveTimeout) {
                  clearTimeout(customStyle.current.inactiveTimeout);
                }
                container.current.classList.add(style.animation);
                customStyle.current.inactiveTimeout = setTimeout(function () {
                  changeStyle();
                }, 5000);
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return _onResizeAndAddTimeout.apply(this, arguments);
      }
      onResizeAndAddTimeout();
      var removeResizeListeners = addResizeListeners();
      return function willUnmount() {
        removeResizeListeners();
        if (customStyle.current.inactiveTimeout) {
          clearTimeout(customStyle.current.inactiveTimeout);
        }
      };
    }, []);
  }
  (0, _react.useEffect)(function () {
    var handleKeyDown = function handleKeyDown(e) {
      var isCtrl = e.ctrlKey;
      if (isCtrl || !editor) {
        if (e.key === "5") {
          var save = /*#__PURE__*/function () {
            var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 1000);
                    });
                  case 2:
                    console.log("[APP]", "Saving...");
                    _context3.next = 5;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 1000);
                    });
                  case 5:
                    window.dataForServerSaving = {
                      blob: null
                    };
                    console.log("[APP]", "The data for server saving is ready...");
                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function save() {
              return _ref.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          save();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.canvas, (_clsx = {}, (0, _defineProperty2["default"])(_clsx, style[customStyle.current.className], customStyle.current.className), (0, _defineProperty2["default"])(_clsx, style.fullWidth, fullWidth), (0, _defineProperty2["default"])(_clsx, style.fullPage, fullPage), _clsx), (0, _defineProperty2["default"])({}, className, className)),
    ref: container,
    onClick: changeStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.bg
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.center
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.scale,
    ref: scaleRef,
    style: {
      transform: "scale(" + scale + ")"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.composition
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.group
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.bgGroup
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.wall
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer1
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.gray
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.grayEffect
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.table
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer1
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.brown
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.brownEffect
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.objectGroup
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.vase
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer1
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.tableShadow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.wallShadow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part4)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part5)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part6)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part7)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part8)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part9)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part10)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part11)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer2
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part4)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part5)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part6)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part7)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part8)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part9)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part10)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part11)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part12)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.layer3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.layer4)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part4)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part5)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part6)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part7)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.layer5)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.layer6)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part4)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part5)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part6)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part7)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.layer7)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part4)
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.bulrush
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer1
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.wallShadow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part4)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer2
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.stalk
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.concave)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.cylindricalHead
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer3
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.cylindricalHead
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer4
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.cylindricalHead
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.finial
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer1
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.tableShadow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.wallShadow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer2
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.coneLower
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part4)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.dodecahedron
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.pentagon)
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.pentagon)
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.pentagon)
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part4)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.pentagon)
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part5)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.pentagon)
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part6)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.pentagon)
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.coneUpper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part3)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part4)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.layer3
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.dodecahedron
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part1)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShape, style.part2)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.defaultShapeInner, style.convex)
  })))))))))));
}